export const scrollableSx = (theme: any) => ({
  overflowY: 'auto' as const,
  overscrollBehavior: 'contain' as const,
  scrollbarWidth: 'thin' as const,
  scrollbarColor: `${theme.colors.text.secondary} ${theme.colors.border}33`,
  '&::-webkit-scrollbar': { width: 10 },
  '&::-webkit-scrollbar-track': { backgroundColor: `${theme.colors.border}55`, borderRadius: 8 },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.colors.text.secondary,
    borderRadius: 8,
    border: '2px solid transparent',
    backgroundClip: 'content-box',
  },
  '&::-webkit-scrollbar-thumb:hover': { backgroundColor: theme.colors.text.primary },
});
